/* ===============================================================
   Inform Bundle Handler (v7 - Optimized Safe Path)
   Adds selected inform accessories to the cart FIRST, then hands
   control back to the theme's native ajax-submit handler so the
   main product is added and the cart drawer slides open.

   Cleaned up to prevent race conditions with theme updateView cycles.
   =============================================================== */

(function () {
  'use strict';

  var DEBUG = true;
  var passthrough = false;

  function log() {
    if (!DEBUG) return;
    var args = ['[inform-bundle]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function getSelectedInformItems() {
    var checkboxes = document.querySelectorAll(
      '.offer--inform .offer__inform-checkbox:checked'
    );
    var items = [];
    for (var i = 0; i < checkboxes.length; i++) {
      var cb = checkboxes[i];
      if (!cb.value) continue;
      items.push({
        id: parseInt(cb.value, 10),
        quantity: 1,
        properties: {
          _bundle_source: 'inform',
          _bundle_parent_product: getMainProductId(cb)
        }
      });
    }
    return items;
  }

  function getMainProductId(checkbox) {
    var form = checkbox.closest('[data-product-form]');
    if (form && form.dataset.productId) return form.dataset.productId;
    return '';
  }

  function addAccessories(informItems) {
    var payload = { items: informItems };
    log('POST /cart/add.js (accessories only):', payload);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error(err.description || err.message || 'Accessory add failed');
        });
      }
      return response.json();
    });
  }

  function clearInformSelections() {
    var checkboxes = document.querySelectorAll(
      '.offer--inform .offer__inform-checkbox:checked'
    );
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('is-loading');
    } else {
      btn.classList.remove('is-loading');
    }
  }

  function handleClick(e, btn) {
    if (passthrough) {
      log('passthrough mode, letting theme handle this click');
      return;
    }

    var informItems = getSelectedInformItems();

    if (informItems.length === 0) {
      log('no accessories selected, theme handles natively');
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    log('intercepting to add', informItems.length, 'accessories first');
    setButtonLoading(btn, true);

    addAccessories(informItems)
      .then(function (response) {
        log('accessories added, handing control to theme');
        clearInformSelections();
        setButtonLoading(btn, false);

        document.dispatchEvent(new CustomEvent('inform:accessories_added', {
          bubbles: true,
          detail: { bundle: informItems, response: response }
        }));

        // Set passthrough mode true to let the native theme click event pass through
        passthrough = true;
        log('re-triggering click for theme native handler');
        btn.click();

        // Reset passthrough immediately after execution
        setTimeout(function () {
          passthrough = false;
        }, 100);
      })
      .catch(function (err) {
        console.error('[inform-bundle] accessory add failed:', err);
        setButtonLoading(btn, false);
        alert(err.message || 'Could not add accessories. Please try again.');
      });
  }

  function attachHandlers() {
    var informSections = document.querySelectorAll('.offer--inform');
    if (informSections.length === 0) {
      log('no inform sections on page, standing down');
      return;
    }

    var buttons = document.querySelectorAll('[data-add-to-cart-trigger]');
    log('found', buttons.length, 'ATC button(s), attaching interceptor');

    for (var i = 0; i < buttons.length; i++) {
      (function (button) {
        button.addEventListener('click', function (e) {
          handleClick(e, button);
        }, true);
      })(buttons[i]);
    }
  }

  function init() {
    log('handler initialized (v7 optimized)');
    attachHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();